const globalConfig = {
  // CMS API URL
  STAGING_CMS_API_URL: "https://cms.tdcx.com",
  PROD_CMS_API_URL: "https://cms.tdcx.com",
  // API URL
  STAGING_API_URL: "https://staging-api.tdcx.com",
  PROD_API_URL: "https://api.tdcx.com",
  // =============================================================================
  showChatBotDuration: 60 * 60 * 24 * 7,
  hideChatBotDuration: 60 * 60 * 24 * 7,
  CVAcceptFileFormat: [
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "text/plain",
    "image/jpg",
    "image/png",
    "image/jpeg"
  ],
  CVMaxFileSize: 10485760 // 10mb
};

export default globalConfig;
